import {createApp} from 'vue'
import SendCalculationStepContent from './SendCalculationStepContent'

const el = '.nyk-component--contact-step-content'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((SendCalculationStepContentDOM)=>{
            const component = createApp(SendCalculationStepContent).use(Store)
            component.mount(SendCalculationStepContentDOM)
        })
    }
}